import { defineMessages } from "react-intl";

export const messages = defineMessages({
  submitButton: {
    id: "dashboardview.dialog.updateAndNotifyUser.submit.label",
    defaultMessage: "Save and notify user",
    description: "submit button label",
  },
  success: {
    id: "dashboardview.dialog.updateAndNotifyUser.success.message",
    defaultMessage: "Triggered notifications for {numberOfBookings} bookings",
    description: "success message",
  },
  dialogTitle: {
    id: "dashboardview.dialog.updateAndNotifyUser.title",
    defaultMessage:
      "We are lacking contact details (mail and/or phonenumber) for {name}",
    description: "Title for dialog",
  },
  dialogSubtitle: {
    id: "dashboardview.dialog.updateAndNotifyUser.subtitle",
    defaultMessage:
      "Booking information including link, can be sent per email and/or SMS to patients through the videomeeting platform. In order to do that, mail and/or mobile phone number must be filled in below. The contact details of the patient must not be added for every new video visit.",
    description: "Subtitle for dialog",
  },
});
